import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/productCenter',
    name: 'productCenter',
    component: () => import('../views/productCenter.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('../views/solution.vue')
  },
  {
    path: '/serviceSupport',
    name: 'serviceSupport',
    component: () => import('../views/serviceSupport.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../views/aboutUs.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/contactUs.vue')
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../components/pageDetail/newsDetail.vue')
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: () => import('../components/pageDetail/productDetail.vue')
  },
  {
    path: '/solutionDetail',
    name: 'solutionDetail',
    component: () => import('../components/pageDetail/solutionDetail.vue')
  },
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  // 滚动到顶部
  window.scrollTo(0, 0);
  next();
});
export default router

// 解决路由重复跳转报错
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}